module.exports = __webpack_public_path__ + "static/media/hadith-dars.9bd7cec0.webp";